import { captureMessage } from '@sentry/sveltekit';
import { redirect } from '@sveltejs/kit';

type Params = {
  currentSlug: string;
  entitySlug: string | null;
  redirectPath: string;
};

export function handleSlugMismatch({ currentSlug, entitySlug, redirectPath }: Params) {
  if (entitySlug !== currentSlug) {
    captureMessage('Slug mismatch', { extra: { from: currentSlug, to: entitySlug }, level: 'warning' });

    throw redirect(301, redirectPath);
  }
}
